import React from 'react';

const StatusOk = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 10 10" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.875C0 2.18261 2.18261 0 4.875 0C7.56739 0 9.75 2.18261 9.75 4.875C9.75 7.56739 7.56739 9.75 4.875 9.75C2.18261 9.75 0 7.56739 0 4.875ZM4.875 0.75C2.59683 0.75 0.75 2.59683 0.75 4.875C0.75 7.15317 2.59683 9 4.875 9C7.15317 9 9 7.15317 9 4.875C9 2.59683 7.15317 0.75 4.875 0.75ZM6.71117 3.60133C6.85761 3.74778 6.85761 3.98522 6.71117 4.13166L4.57766 6.26516C4.43122 6.41161 4.19378 6.41161 4.04733 6.26516L3.32008 5.53791C3.17364 5.39147 3.17364 5.15403 3.32008 5.00758C3.46653 4.86114 3.70397 4.86114 3.85041 5.00758L4.3125 5.46967L6.18084 3.60133C6.32728 3.45489 6.56472 3.45489 6.71117 3.60133Z" fill="#63C174"/>
        </svg>
    );
};

export default StatusOk;